import { render, staticRenderFns } from "./TwDashBoardAlert.vue?vue&type=template&id=5d75319a&scoped=true&"
import script from "./TwDashBoardAlert.vue?vue&type=script&lang=js&"
export * from "./TwDashBoardAlert.vue?vue&type=script&lang=js&"
import style0 from "./TwDashBoardAlert.vue?vue&type=style&index=0&id=5d75319a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d75319a",
  null
  
)

export default component.exports